import * as yup from 'yup';

import {
    passwordMatchValidationRule,
    passwordValidationRule,
} from './validationRules';

export const createPasswordSchema = yup.object({
    password: passwordValidationRule,
    confirmPassword: passwordMatchValidationRule('password'),
});
